// @flow
import _ from 'lodash';
import ko from 'rgs-knockout';
import type { Observable } from 'rgs-knockout';

import BaseViewModel from 'rgs-nfd-ui-kit/ko-components/tree/BaseViewModel';
import { observableISODate } from 'observable-iso-date';
import vb from 'validation-builder';

const dateToDay = new Date();
const dateMaxEarly = new Date();
const dateMaxLate = new Date();
const yearMaxEarly = 1990;
const offsetToFeature = 10;

const getObservableISODate = (value) => (observableISODate(value).extend({ toFromJs: true }));

const DEFAULT_PLACEHOLDER = 'ДД.ММ.ГГГГ';
const DEFAULT_INPUT_MASK = '99.99.9999';
dateMaxEarly.setFullYear(yearMaxEarly, 0, 1);
dateMaxLate.setFullYear(dateToDay.getFullYear() + offsetToFeature, 0, 1);

const DEFAULT_DATE_START = getObservableISODate(dateMaxEarly);
const DEFAULT_DATE_END = getObservableISODate(dateMaxLate);

export type TInputOptions = {
	dateFrom: Observable<Date>,
	dateTo: Observable<Date>,

	dateFromPrefix?: string,
	dateToPrefix?: string,
	dateFromLabel?: string,
	dateToLabel?: string,
	dateFromIsRequire?: boolean;
	dateToIsRequire?: boolean;
	dateFromRequireMessage?: string,
	dateToRequireMessage?: string,
	startDate?: string | Observable<Date>,
	endDate?: string | Observable<Date>,
	focusNextInput?: boolean,
	placeholder?: string,
	inputMask?: string,
	cssClassesFrom: { [string]: boolean },
	cssClassesTo: { [string]: boolean },
	isStartDateDisabled: { [string]: boolean },
	isEndDateDisabled: { [string]: boolean },
}

type Options = {
	dateFrom: Observable<Date>,
	dateTo: Observable<Date>,
	dateFromPrefix: string,
	dateToPrefix: string,
	dateFromLabel?: string,
	dateToLabel?: string,
	dateFromIsRequire: boolean;
	dateToIsRequire: boolean;
	dateFromRequireMessage: string,
	dateToRequireMessage: string,
	startDate: string | Observable<Date>,
	endDate: string | Observable<Date>,
	focusNextInput: boolean,
	placeholder: string,
	inputMask: string,
	isStartDateDisabled: { [string]: boolean },
	isEndDateDisabled: { [string]: boolean },
}

export class DatePeriod extends BaseViewModel {
	options: Options;

	constructor (options: TInputOptions, elementContent: any) {
		super(options, elementContent);

		this.options = _.defaults(options, {
			placeholder: DEFAULT_PLACEHOLDER,
			inputMask: DEFAULT_INPUT_MASK,
			focusNextInput: true,
			cssClassesFrom: { 'col-xs-12': true, 'col-sm-6': true },
			cssClassesTo: { 'col-xs-12': true, 'col-sm-6': true },
			dateFromRequireMessage: 'Укажите значение',
			dateToRequireMessage: 'Укажите значение',
			dateFromPrefix: 'С',
			dateToPrefix: 'По',
			dateFromLabel: '',
			dateToLabel: '',
			dateFrom: getObservableISODate(),
			dateTo: getObservableISODate(),
			dateFromIsRequire: false,
			dateToIsRequire: false,
			startDate: DEFAULT_DATE_START,
			endDate: DEFAULT_DATE_END,
			isStartDateDisabled: false,
			isEndDateDisabled: false,
		});

		if (!ko.isObservable(this.options.dateFrom) || !ko.isObservable(this.options.dateTo)) {
			throw new Error('dateFrom и dateTo должны быть Observable значаниями');
		}

		if (_.isString(this.options.startDate)) {
			this.options.startDate = getObservableISODate(this.options.startDate);
		} else if (!ko.observable(this.options.startDate)) {
			throw new Error('startDate должен быть Observable или String значаниями');
		}

		if (_.isString(this.options.endDate)) {
			this.options.endDate = getObservableISODate(this.options.endDate);
		} else if (!ko.observable(this.options.endDate)) {
			throw new Error('endDate должен быть Observable или String значаниями');
		}

		this.options.dateFrom.extend({
			validation: vb.all([
				vb.required(this.options.dateFromIsRequire, this.options.dateFromRequireMessage),
				vb.momentIsValid(),
			]),
		});

		this.options.dateTo.extend({
			validation: vb.all([
				vb.required(this.options.dateToIsRequire, this.options.dateToRequireMessage),
				vb.momentIsValid(),
			]),
		});
	}

	get dateFrom (): Observable<Date> {
		return this.options.dateFrom;
	}

	get dateTo (): Observable<Date> {
		return this.options.dateTo;
	}
}

